module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAXUlEQVQ4y2NgGByg1f4/Mv773gkrfiytjIKHgAEX7jiCMdkGNOx2BGOSDVh1xvE/TxeCz98NESPJBQevOcL5IDbJXujc5/i/aocDGIPYJBvw6Aki9GHswZwOhjQAAObMbcj71ddyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/SN.png
// module id = 1266
// module chunks = 0